'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _remarkable = require('remarkable');

var _remarkable2 = _interopRequireDefault(_remarkable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var LegalBody = function (_React$Component) {
  _inherits(LegalBody, _React$Component);

  function LegalBody() {
    _classCallCheck(this, LegalBody);

    return _possibleConstructorReturn(this, (LegalBody.__proto__ || Object.getPrototypeOf(LegalBody)).apply(this, arguments));
  }

  _createClass(LegalBody, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var input = content.input;
      var id = config.id,
          isHTML = config.isHTML,
          theme = config.theme;


      var ORGANISM_NAME = 'legal-body';

      var legalBodyClasses = (0, _classnames2.default)('' + ORGANISM_NAME, theme || 'theme-background-color-white', className);

      /*
        Remarkable (https://github.com/jonschlinkert/remarkable) documentation is not comprehensive
        enough, so below are listed all available core|block|inline rules for reference purposes.
      */

      // need to start the 'full' instance and start disabling from there
      // loading default instance will not allow to enable some features
      var md = new _remarkable2.default('full', {
        html: false,
        linkify: true,
        typographer: true
      });

      /*
        enabled options:
          'block', // breaks if disabled
          'inline', // breaks if disabled
          'references', ???
          'replacements',
          'smartquotes',
      */
      md.core.ruler.disable(['abbr', 'abbr2', 'footnote_tail', 'linkify']);

      /*
        enabled options:
          'paragraph', // breaks if disabled
          'state_block', // breaks if disabled
      */
      md.block.ruler.disable(['blockquote', 'code', 'deflist', 'fences', 'footnote',
      // 'Heading',
      'hr', 'htmlblock',
      // 'lheading',
      // 'list',
      'table']);

      /*
        enabled options:
          'emphasis',
          'links',
          'state_inline', // breaks org if disabled
          'sub',
          'sup',
      */
      md.inline.ruler.disable(['autolink', 'backticks', 'del',
      // 'entity',
      'escape', 'footnote_inline', 'footnote_ref', 'htmltag', 'ins', 'mark', 'newline', 'text']);

      var html = isHTML ? input.text : md.render(input.text);

      return _react2.default.createElement(
        'section',
        { className: legalBodyClasses, 'data-building-block': 'organism', id: id },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'col-md-12 center-block' },
              _react2.default.createElement(
                'div',
                null,
                htmlToReactParser.parse(html)
              )
            )
          )
        )
      );
    }
  }]);

  return LegalBody;
}(_react2.default.Component);

exports.default = LegalBody;


LegalBody.defaultProps = {
  config: {
    id: '',
    isHTML: false,
    theme: 'theme-background-color-white'
  },
  content: {
    input: {
      text: '# H1 heading\n\n* [Numquam delectus adipiscing te cum, adhuc Labore Vix(R)](#)\n\n* [Numquam delectus adipiscing te cum, adhuc Labore Vix(R)](#)\n\n1. Numquam delectus adipiscing te cum, adhuc Labore Vix(R)\n\n1. Numquam delectus adipiscing te cum, adhuc Labore Vix(R)\n\n&#42; 2,000 characters maximum is recommended. Inciderint mei, eam decore primis cu.\nNatum omnes neglegentur mel at, numquam delectus adipiscing te cum, adhuc labore vix in.\nLatine delicata convenire at eos, vel dolor feugait an.\n\n## H2 heading\n\n** Vel suavitate maiestatis in, nonumes disputando an vis, et mei atqui dolores.\nQuo id ubique possit reformidans. Esse phaedrum ut mea,\nsuscipit erroribus concludaturque mel ex.\n\n*** Dolor voluptua percipitur no sea, graece integre cotidieque eu mea.\nSea ad iusto praesent instructior. Meliore deleniti ex est, est eu accumsan verterem.\nEu harum democritum adversarium vis.\n\n### H3 heading\n\n^1^Lorem ipsum dolor sit amet, ne accumsan inciderint mei(C), eam decore primis cu^SM^.\n**Natum Omnes(TM)** [Numquam delectus adipiscing te cum, adhuc Labore Vix(R)](#).'
    }
  },
  className: ''
};

LegalBody.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    isHTML: _propTypes2.default.bool,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired
  }),
  content: _propTypes2.default.shape({
    input: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  className: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/legal-body/jsx/LegalBody.js
// module id = 1114
// module chunks = 4